module.exports = __webpack_public_path__ + "img/bg.831929bd.png";